<template>
  <scroll-bar>
    <div class="userInfoContain">
      <img :src="userInfo.u_avatar" class="head" />
      <div class="nameContain">
        <p class="userName">{{ userInfo.u_nickname }}</p>
        <img :src="badgeUrl" class="badgeIcon" v-if="badgeUrl" />
      </div>
      <div class="levelContain">
        <p class="text">
          创作分<span class="num">{{ userScore.user_score }}</span>
        </p>
      </div>
    </div>
    <el-dropdown class="writeContain">
      <el-button
        size="mini"
        type="primary"
        class="toWriteContain"
        @click="toAdd(1)"
      >
        <p>内容创作</p>
        <img src="../../../assets/level/editIcon.png" class="icon" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="toAdd(1)">文章</el-dropdown-item>
        <el-dropdown-item @click.native="toAdd(2)">视频</el-dropdown-item>
        <el-dropdown-item @click.native="toAdd(3)">图集</el-dropdown-item>
        <el-dropdown-item @click.native="toAdd(4)">合集</el-dropdown-item>
        <el-dropdown-item @click.native="toAdd(6)">帖子</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-menu
      :default-active="activeIndex"
      :show-timeout="200"
      mode="vertical"
      text-color="#333333"
      unique-opened
      :default-openeds="openeds$"
    >
      <template v-for="item in asideMenuConfig">
        <!-- 如果只有一级菜单 -->
        <router-link
          v-if="!item.children.length && item.openType == 'new'"
          :to="item.ap_url"
          :key="item.ap_name"
          tag="a"
          target="_blank"
        >
          <el-menu-item :index="item.ap_url" :disabled="true">
            <i v-if="item.ap_icon" :class="item.ap_icon" />
            <span v-if="item.ap_name" slot="title">{{ item.ap_name }}</span>
          </el-menu-item>
        </router-link>
        <router-link
          v-else-if="!item.children.length && item.openType != 'new'"
          :to="item.ap_url"
          :key="item.ap_name"
        >
          <el-menu-item :index="item.ap_url">
            <i v-if="item.ap_icon" :class="item.ap_icon" />
            <span v-if="item.ap_name" slot="title">{{ item.ap_name }}</span>
          </el-menu-item>
        </router-link>

        <!-- 如果有二级菜单 -->
        <el-submenu
          v-else
          :index="item.ap_name || item.ap_url"
          :key="item.name"
        >
          <template slot="title">
            <i v-if="item != '1' && item.ap_icon" :class="item.ap_icon" />
            <span v-if="item && item.ap_name" slot="title">{{
              item.ap_name
            }}</span>
          </template>

          <!-- 二级路由的设置，根据数据判断是否要加新页面的打开操作 -->
          <template v-for="child in item.children">
            <router-link
              v-if="!child.children.length && !child.tag"
              :to="item.ap_url + child.ap_url"
              :key="child.ap_name"
            >
              <el-menu-item :index="item.ap_url + child.ap_url">
                <span v-if="child && child.ap_name" slot="title">{{
                  child.ap_name
                }}</span>
              </el-menu-item>
            </router-link>

            <!-- 如果有tag，说明需要新打开页面-->
            <el-menu-item
              v-if="!child.children.length && child.tag"
              :to="item.ap_url + child.ap_url"
              :key="child.ap_name"
              tag="a"
              target="_blank"
              class="createList"
            >
              <el-menu-item :index="item.ap_url + child.ap_url">
                <span
                  v-if="child && child.ap_name"
                  slot="title"
                  @click.stop="handleTag(child)"
                  >{{ child.ap_name }}</span
                >
              </el-menu-item>
            </el-menu-item>

            <!-- 如果有三级菜单了，到这里来处理 -->
            <el-submenu
              v-if="
                child.children &&
                child.children.length &&
                child.children.length > 0
              "
              :index="child.ap_name || child.ap_url"
              :key="child.name"
            >
              <template slot="title">
                <i
                  v-if="child != '1' && child.ap_icon"
                  :class="child.ap_icon"
                />
                <span v-if="child && child.ap_name" slot="title">{{
                  child.ap_name
                }}</span>
              </template>
              <template v-for="subChild in child.children">
                <router-link
                  :to="item.ap_url + child.ap_url + subChild.ap_url"
                  :key="subChild.ap_name"
                >
                  <el-menu-item
                    :index="item.ap_url + child.ap_url + subChild.ap_url"
                  >
                    <span v-if="subChild && subChild.ap_name" slot="title">{{
                      subChild.ap_name
                    }}</span>
                  </el-menu-item>
                </router-link>
              </template>
            </el-submenu>
          </template>
        </el-submenu>
      </template>
    </el-menu>

    <el-dialog
      title="请完成实名认证"
      :visible.sync="certificationVisible"
      class="certificationInfoContainer"
      width="1026px"
    >
      <p class="title">
        应网络实名制要求，完成实名认证后才可以发表文章视频等内容，以保护账号安全。
      </p>
      <div class="borderContainer">
        <div>
          <p class="infoTitle">1、打开“顶端新闻”App</p>
          <p class="info">登录当前账号或扫下方二维码下载“顶端新闻”App</p>
          <img
            src="../../../assets/85d81507ebe84f210b224bf8e02c6d76966336a7fff89e02e5f088ed492cce1f.png"
            class="qrCode"
          />
        </div>
        <div>
          <p class="infoTitle">2、打开“我的”</p>
          <p class="info">点击“实名认证”完成实名认证</p>
          <img
            src="../../../assets/shiming@2x.png"
            class="app"
            v-if="u_cert != 1"
          />
          <img src="../../../assets/shenqing@2x.png" class="app" v-else />
        </div>
      </div>
    </el-dialog>

    <BanDialog
      ref="banShow"
      :isShow="isBanned"
      :allowClose="true"
      @closeBan="isBanned = false"
    ></BanDialog>

    <div class="toolContain">
      <div class="serviceBtn" @click="showService = true">
        <img src="../../../assets/service.png" class="serviceIcon" />
      </div>
    </div>

    <el-dialog
      :visible.sync="showService"
      top="5vh"
      :center="true"
      width="350px"
    >
      <iframe
        :src="`https://cs.dingxinwen.com/#/welcome?uid=${userInfo.u_id}&nickname=${userInfo.u_nickname}`"
        style="height: 80vh"
      />
    </el-dialog>
  </scroll-bar>
</template>

<script>
import ScrollBar from "./ScrollBar";
import { mapGetters } from "vuex";
import { isCreation$ } from "@/utils/store-rx.js";
import { dispatch } from "frer";
import tools from "@/utils/tools.js";
import { BehaviorSubject } from "rxjs";
import { USER_HOST, SWNEWS_HOST, NEWS_HOST } from "../../../constants/apiHosts";
import BanDialog from "../../../components/banDialog.vue";

export default {
  name: "SideBar",
  components: {
    ScrollBar,
    BanDialog,
  },
  props: {
    userScore: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      asideMenuConfig: [
        {
          ap_name: "首页",
          ap_url: "/index",
          ap_icon: "el-icon-s-home",
          ap_sort: 1,
          children: [],
        },
        // {
        //   ap_name: "创作",
        //   ap_sort: 2,
        //   ap_icon: "el-icon-edit",
        //   ap_url: "",
        //   ap_tag: "creation",
        //   children: [
        //     {
        //       ap_name: "创作文章",
        //       ap_url: "/scriptWrite",
        //       children: [],
        //       ap_sort: 1,
        //       tag: "a",
        //       target: "_blank",
        //     },
        //     {
        //       ap_name: "创作视频",
        //       ap_url: "/videoWrite",
        //       ap_sort: 2,
        //       children: [],
        //       tag: "a",
        //       target: "_blank",
        //     },
        //     {
        //       ap_name: "创作图集",
        //       ap_url: "/graphWrite",
        //       ap_sort: 3,
        //       children: [],
        //       tag: "a",
        //       target: "_blank",
        //     },
        //     {
        //       ap_name: "创作合集",
        //       ap_url: "/videoWrite?isPack=1",
        //       ap_sort: 4,
        //       children: [],
        //       tag: "a",
        //       target: "_blank",
        //     },
        //   ],
        // },
        {
          ap_name: "稿库",
          ap_url: "",
          ap_icon: "el-icon-s-order",
          ap_sort: 3,
          children: [
            {
              ap_name: "稿件库",
              ap_url: "/personalScript",
              ap_sort: 2,
              children: [],
            },
            {
              ap_name: "草稿库",
              ap_url: "/draft",
              ap_sort: 3,
              children: [],
            },
            // {
            //   ap_name: "待审稿库",
            //   ap_url: "/audit",
            //   ap_sort: 4,
            //   children: [],
            // },
            /* {
              ap_name: "待发稿库",
              ap_url: "/preRelease",
              ap_sort: 5,
              children: [],
            }, */
          ],
        },
        {
          ap_name: "素材",
          ap_url: "",
          ap_icon: "el-icon-picture",
          ap_sort: 7,
          children: [
            {
              ap_name: "我的素材",
              ap_url: "/material/0",
              ap_sort: 1,
              children: [],
            },
            {
              ap_name: "公共素材",
              ap_url: "/material/1",
              ap_sort: 2,
              children: [],
            },
          ],
        },
        {
          ap_name: "榜单",
          ap_url: "/rank",
          ap_icon: "el-icon-trophy",
          ap_sort: 8,
          children: [],
          openType: "new",
        },
        {
          ap_name: "权益中心",
          ap_url: "/rights",
          ap_icon: "el-icon-s-help",
          ap_sort: 9,
          children: [],
        },
        {
          ap_name: "政务号",
          ap_url: "/govAffairs",
          ap_icon: "el-icon-s-custom",
          ap_sort: 10,
          children: [],
        },
        {
          ap_name: "企业号",
          ap_url: "/enterprise",
          ap_icon: "el-icon-s-cooperation",
          ap_sort: 10,
          children: [],
        },
        {
          ap_name: "帮助中心",
          ap_url: "/helpCenter",
          ap_icon: "el-icon-question",
          ap_sort: 11,
          children: [],
        },
        // {
        //   ap_name: "舆情",
        //   ap_url: "",
        //   ap_icon: "el-icon-s-data",
        //   ap_sort: 9,
        //   children: [
        //     {
        //       ap_name: "热门榜单",
        //       ap_url: "/hot",
        //       ap_sort: 1,
        //       children: [],
        //     },
        //     {
        //       ap_name: "历史报刊",
        //       ap_url: "/newspaper",
        //       ap_sort: 2,
        //       children: [],
        //     },
        //   ],
        // },
      ],
      certificationVisible: false,
      u_cert_status: 0,
      u_cert: 0,
      isBanned: false,
      userInfo: {},
      badgeUrl: "",
      showService: false,
    };
  },
  computed: {
    ...mapGetters(["activeIndex", "menuFresh"]),
  },
  subscriptions() {
    return {
      openeds$: new BehaviorSubject([]),
    };
  },
  watch: {
    menuFresh(newVal) {
      if (newVal) {
        //this.getMenu();
        this.$store.state.common.menuFresh = false;
      }
    },
  },
  created() {
    this.u_cert_status = localStorage.getItem("u_cert_status");
    this.u_cert = localStorage.getItem("u_cert");

    setTimeout(() => {
      this.u_cert_status = localStorage.getItem("u_cert_status");
      this.u_cert = localStorage.getItem("u_cert");
    }, 3000);

    this.getUserInfo();
    //this.getMenu();
    this.getUserWearBadge();
    this.getShortPlay();
  },
  mounted() {},
  methods: {
    handleTag(item) {
      let banData = localStorage.getItem("banData");
      if (banData) {
        banData = JSON.parse(banData);
      }

      if (this.u_cert != 1) {
        this.certificationVisible = true;
      } else if (
        item.ap_name.indexOf("创作") >= 0 &&
        banData.ban_type == 1 &&
        banData.ban_range_type.indexOf("1") > -1
      ) {
        this.$refs.banShow.getReason(localStorage.getItem("token"));
        this.isBanned = true;
      } else {
        let routeData = this.$router.resolve({
          path: item.ap_url,
        });
        window.open(routeData.href, "_blank");
      }
    },
    getMenu() {
      this.$axios
        .post(`${USER_HOST}/admin/account/rolePermissionList`, {})
        .then((res) => {
          if (res.data.code == 0) {
            this.asideMenuConfig = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    jumpToMain() {
      this.$router.push({
        path: "/personalScript",
      });
    },
    getMenu() {
      this.$axios.get(`${SWNEWS_HOST}/api/user/getToolList`).then((res) => {
        if (res.data.code == 0) {
          res.data.data.forEach((item) => {
            if (item.code == "oddjobs") {
              this.asideMenuConfig.push({
                ap_name: "工具",
                ap_url: "",
                ap_icon: "el-icon-s-cooperation",
                ap_sort: 10,
                children: [
                  {
                    ap_name: "招聘管理",
                    ap_url: "/tools/job/index",
                    ap_sort: 1,
                    children: [],
                  },
                ],
              });
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getUserInfo() {
      this.$axios
        .get(`${SWNEWS_HOST}/api/user/mpBaseUserinfo`, {})
        .then((res) => {
          if (res.data.code == 0) {
            this.userInfo = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getUserWearBadge() {
      this.$axios
        .get(`${SWNEWS_HOST}/api/userBadge/getUserWearBadge`, {})
        .then((res) => {
          if (res.data.code == 0) {
            this.badgeUrl = res.data.data.cover_url || "";
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getShortPlay() {
      this.$axios
        .post(`${SWNEWS_HOST}/api/microDrama/isHasAuth`, {})
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.check) {
              this.asideMenuConfig.forEach((item) => {
                if (item.ap_name == "稿库") {
                  item.children.push({
                    ap_name: "短剧",
                    ap_url: "/shortPlay",
                    ap_sort: 4,
                    children: [],
                  });
                }
              });
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    toAdd(type) {
      if (this.u_cert != 1) {
        this.certificationVisible = true;
        return;
      }
      let banData = localStorage.getItem("banData");
      if (banData) {
        banData = JSON.parse(banData);
      }
      if (
        banData.ban_type == 1 &&
        ((type != 6 && banData.ban_range_type.indexOf("1") > -1) ||
          (type == 6 && banData.ban_range_type.indexOf("3") > -1))
      ) {
        this.$refs.banShow.getReason(localStorage.getItem("token"));
        this.isBanned = true;
        return;
      }

      if (type == 1) {
        //往写稿跳转
        let routeData = this.$router.resolve({
          path: "/scriptWrite",
          isMine: 1,
        });
        window.open(routeData.href, "_blank");
      } else if (type == 2) {
        //往视频跳转
        let routeData = this.$router.resolve({
          path: "/videoWrite",
          isMine: 1,
        });
        window.open(routeData.href, "_blank");
      } else if (type == 3) {
        //往图集跳转
        let routeData = this.$router.resolve({
          path: "/graphWrite",
          isMine: 1,
        });
        window.open(routeData.href, "_blank");
      } else if (type == 4) {
        //往合集跳转
        let routeData = this.$router.resolve({
          path: "/videoWrite?isPack=1",
        });
        window.open(routeData.href, "_blank");
      } else if (type == 6) {
        //往帖子跳转
        let routeData = this.$router.resolve({
          path: "/post",
        });
        window.open(routeData.href, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-container {
  transition: width 0.28s;
  width: 220px !important;
  z-index: 1001;
  overflow-x: hidden;
  background-color: #fff;
  height: calc(100vh - 100px);
  overflow-y: scroll;

  .userInfoContain {
    border-radius: 8px 8px 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px 16px 0 16px;

    .head {
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }

    .nameContain {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 8px;

      .userName {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 18px;
        font-weight: 600;
        line-height: 30px;
      }

      .badgeIcon {
        width: 24px;
        height: 24px;
        margin-left: 4px;
      }
    }

    .levelContain {
      width: 100%;
      border-radius: 6px;
      background: #f6f7f9;
      margin-top: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 9px 0;

      .text {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 12px;
        font-weight: 400;
        line-height: 22px;
        padding: 4px 0;

        .num {
          color: #ea0e0e;
          font-family: "PingFang SC";
          font-size: 16px;
          font-weight: 600;
          line-height: 22px;
          margin-left: 8px;
        }
      }
    }
  }

  .writeContain {
    width: 100%;
    padding: 0 16px;
    margin-top: 20px;
    .toWriteContain {
      width: 100%;
      border-radius: 6px;

      /deep/span {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;

        .icon {
          height: 11px;
          margin-left: 2px;
        }
      }
    }
  }

  a {
    display: inline-block;
    width: 100%;
  }

  .el-menu {
    padding: 20px 16px;
    width: 100% !important;
    border: none;
    border-radius: 0 0 8px 8px;

    .el-submenu__title {
      span {
        font-size: 16px;
        font-weight: bold;
      }
    }
    /deep/.el-submenu__title:hover {
      background-color: #fff !important;
    }

    .el-menu-item {
      font-size: 16px;
      font-weight: bold;
      width: 100%;
      min-width: unset;
      border-radius: 6px;
      margin: 3px 0;
      display: flex;
      align-items: center;
      height: 46px;
    }
    .el-menu-item.is-active {
      background: #ffe6e6 !important;
      color: #ea0e0e;
    }
    .el-menu-item:hover {
      background: #ffe6e6 !important;
      color: #ea0e0e;
    }
    .el-menu-item.is-disabled {
      opacity: 1;
      cursor: pointer;
    }
    // 子菜单下的样式
    .el-menu--inline {
      .el-menu-item {
        color: #666666 !important;
      }
      .el-menu-item.is-active {
        background: #ffe6e6 !important;
        color: #ea0e0e !important;
      }
      .el-menu-item:hover {
        background: #ffe6e6 !important;
        color: #ea0e0e !important;
      }
    }
    /deep/.createList {
      padding-left: 0 !important;
      padding-right: 0 !important;

      .el-menu-item {
        padding: 0 !important;
      }

      span {
        width: 100%;
        height: 100%;
        display: block;
        padding-left: 40px;
      }
    }
  }

  .certificationInfoContainer {
    /deep/.el-dialog__header {
      padding: 20px 32px;

      .el-dialog__title {
        font-size: 16px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #333333;
        line-height: 22px;
      }
    }

    /deep/.el-dialog__body {
      padding: 10px 32px 41px 32px;

      .title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        margin-bottom: 20px;
      }

      .borderContainer {
        height: 255px;
        border-radius: 6px;
        border: 1px solid #dcdfe6;
        display: flex;
        padding: 28px 32px 0 32px;
        justify-content: space-between;

        div {
          flex: 1;

          .infoTitle {
            font-size: 16px;
            font-family: PingFang-SC-Heavy, PingFang-SC;
            font-weight: 800;
            color: #333333;
            line-height: 22px;
            margin-bottom: 10px;
          }

          .info {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
          }

          .qrCode {
            width: 118px;
            margin: 22px 0 0 117px;
          }

          .app {
            width: 198px;
            margin: 20px 0 0 43px;
          }
        }
      }
    }
  }

  .toolContain {
    position: fixed;
    right: 30px;
    bottom: 20px;
    z-index: 10;

    .serviceBtn {
      width: 48px;
      height: 48px;
      border-radius: 4px;
      background: #fff;
      padding: 11px;
      cursor: pointer;
      box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.12);

      .serviceIcon {
        width: 26px;
      }
    }
  }
}
</style>
